import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { IFeeSection } from '../organizeFees';
import { FeeSectionTableColumn } from './FeeSectionTableColumn';
import { ITableColumn } from './getColumns';
import { StyledTableNumberColumn, StyledTableRow } from './StyledTable';

export interface ITotalsRowProps {
  columns: ITableColumn[];
  feeSection: IFeeSection;
}

const NoTotals: string[] = [
  eFeePropertyNames.Name,
  eFeePropertyNames.Payee,
  eFeePropertyNames.Status,
  eFeePropertyNames.NettedOut,
];

export const TotalsRow: React.FC<ITotalsRowProps> = ({ columns, feeSection }) => {
  const showTotalInColumn = columns.find(
    (value, index) => NoTotals.includes(value.label) && !NoTotals.includes(columns[index + 1]?.label)
  )?.label;
  return (
    <StyledTableRow className={`items-baseline font-bold`}>
      <StyledTableNumberColumn />
      {columns.map((column) => (
        <React.Fragment key={`${feeSection.sectionDefinition.statementSectionDefinitionId}-${column.label}`}>
          {showTotalInColumn === column.label && <div className={'pl-6 text-base font-medium'}>Totals</div>}
          {!NoTotals.includes(column.label) && (
            <FeeSectionTableColumn
              columnValue={column.value(feeSection.sectionData?.sectionPropertyTotals || {})}
              columnName={column.label}
              columnVisible={column.isVisible}
            />
          )}
          {showTotalInColumn !== column.label && NoTotals.includes(column.label) && <div></div>}
        </React.Fragment>
      ))}
      <div></div>
    </StyledTableRow>
  );
};
